{
  "buttons": {
    "saveSettings": "Save settings"
  },
  "login": {
    "welcomeBack": "Welcome back!",
    "pleaseLogin": "Please login to your account.",
    "terms": "Terms of use.",
    "privacy": "Privacy policy",
    "labels": {
      "username": "Username",
      "password": "Password",
      "rememberMe": "Remember me",
      "forgotPassword": "Forgot password"
    },
    "code": {
      "enter": "Enter code from email",
      "resend": "Resend code"
    },
    "error": {
      "unexpected": "An unexpected error occurred. Please try again.",
      "credentials": "Invalid email or password. Please try again.",
      "unknown": "An unknown error occurred. Please try again.",
      "otpFailed": "Verification failed. Please try again.",
      "otpInvalid": "Invalid verification code. Please try again.",
      "enterCode": "Please enter the verification code"
    }
  },
  "register": {
    "title": "Invitation",
    "welcome": "Welcome!",
    "setPassword": "Please set your password",
    "label": {
      "passwordConfirm": "Confirm password"
    },
    "message": {
      "passwordSet": "Your password has been successfully set. You can now proceed to the login page.",
      "confirm": "Thank you for registering.",
      "seeYouAround": "See you around!",
      "genericError": "Something went wrong. Please try again!",
      "expiredToken": "This invitation link has expired. Please ask the person who invited you to send a new invitation.",
      "invalidToken": "This invitation link is no longer valid. Please ask the person who invited you to send a new invitation.",
      "declined": "Your invitation has been declined."
    },
    "button": {
      "login": "Login",
      "register": "Register"
    }
  },
  "resetPassword": {
    "title": "Reset Password",
    "message": {
      "emailSent": "An email has been sent to {email} with instructions to reset your password. Please check your inbox.",
      "passwordReset": "Your password has been successfully reset. You can now proceed to the login page.",
      "invalidToken": "Your token is not valid. Please make another request to reset your password.",
      "genericError": "Something went wrong. Please try again!"
    },
    "button": {
      "login": "Login"
    }
  },
  "clients": {
    "addClient": "Add new client",
    "createClient": "Create client",
    "cancel": "Cancel",
    "deactivated": "Deactivated",
    "reactivate": "Reactivate",
    "deleteClient": "Delete finally",
    "clientName": "Whats the clients name?",
    "projects": "Number of map projects:",
    "users": "Number of users:",
    "access": "Ask for access",
    "searchPlaceholder": "Search clients..."
  },
  "mapOverview": {
    "headerTitle": "Map Overview",
    "createMap": "Create new map",
    "live": "Live View",
    "draft": "Preview",
    "edit": "Edit Map",
    "clone": "Clone Map",
    "cloneTemplate": "Clone Template",
    "delete": "Delete Map",
    "access": "Access:",
    "lastEdited": "Last edited:",
    "mapLiveQuotaToggleLabel": "Live",
    "searchPlaceholder": "Search maps...",
    "cloneToClient": {
      "action": "Clone to another client",
      "title": "Clone map to another client",
      "description": "Choose the client that should receive a copy of “{map}”.",
      "currentClient": "current client",
      "noClients": "No clients found.",
      "cancel": "Cancel",
      "confirm": "Clone map",
      "confirmTo": "Clone to {client}",
      "done": "“{map}” has been created in {client}.",
      "open": "Open in Map Builder",
      "close": "Close",
      "failed": "The map could not be cloned."
    }
  },
  "overviewSort": {
    "label": "Sort by",
    "nameAsc": "Name (A–Z)",
    "nameDesc": "Name (Z–A)",
    "createdDesc": "Created (newest first)",
    "createdAsc": "Created (oldest first)",
    "modifiedDesc": "Last modified (newest first)",
    "modifiedAsc": "Last modified (oldest first)",
    "idAsc": "ID (ascending)",
    "idDesc": "ID (descending)"
  },
  "overviewList": {
    "loadMore": "Show more",
    "loading": "Loading more…",
    "end": "All {count} loaded",
    "empty": "Nothing matches your filter"
  },
  "mapAccess": {
    "created": "limited access",
    "draft": "limited access",
    "metered": "partially limited access",
    "published": "publicly accessible"
  },
  "header": {
    "button": {
      "buyLicense": "Buy license"
    },
    "link": {
      "preview": "Preview of changes",
      "live": "Live version"
    }
  },
  "dashboardOptions": {
    "createMap": "Create the Map",
    "drawShapes": "Draw Shapes",
    "drawText": "Text on the Map",
    "drawEdges": "Draw Connection",
    "globalDesign": "Set Global Design",
    "objectTemplates": "Manage Object Templates",
    "mapSettings": "Map Settings",
    "mapLanguages": "Language and Translations",
    "organizeContent": "Organize Content",
    "contentForm": "Content Form",
    "editorsNote": "Editor’s Note",
    "glossary": "Glossary",
    "references": "List of References",
    "headerBar": "Header Bar",
    "tableOfContent": "Table of Contents",
    "mediaAssets": "Manage Media Assets",
    "mediaTemplates": "Media Templates",
    "webSettings": "Manage Web Settings",
    "socialNetworks": "Add Social Networks",
    "cookieConsent": "Add Cookie Consent",
    "seo": "Add SEO Settings",
    "mapUrl": "Manage Map URL",
    "mapAccess": "Manage Map Access",
    "mapEmbed": "Map Embed Code",
    "nodeDesign": "Shape Node Design",
    "nodeContent": "Edit Content",
    "nodeVisibility": "Manage Node Visibility",
    "edgeDesign": "Shape Edge Design",
    "edgeVisibility": "Manage Edge Visibility",
    "quizTool": "Quiz Tool"
  },
  "layerOptions": {
    "settings": "Layer Settings",
    "level": "Z Level",
    "edges": "All Edges",
    "layer": "Layer",
    "node": "Node"
  },
  "options": {
    "style": {
      "dotted": "Dotted",
      "solid": "Solid",
      "dashed": "Dashed"
    },
    "textPosition": {
      "topLeft": "Top Left",
      "top": "Top",
      "topRight": "Top Right",
      "left": "Left",
      "center": "Center",
      "right": "Right",
      "bottomLeft": "Bottom Left",
      "bottom": "Bottom",
      "bottomRight": "Bottom Right"
    },
    "contentBar": {
      "detachedSmall": "Detached (small)",
      "detachedMedium": "Detached (medium)",
      "detachedLarge": "Detached (large)",
      "panelSmall": "Side panel (small)",
      "panelLarge": "Side panel (large)"
    },
    "repeat": {
      "noRepeat": "No-repeat",
      "repeat": "Repeat",
      "repeatX": "Repeat-x",
      "repeatY": "Repeat-y"
    },
    "size": {
      "fill": "Fill",
      "cover": "Cover",
      "contain": "Contain",
      "none": "None"
    }
  },
  "field": {
    "w": "W",
    "h": "H",
    "px": "px",
    "color": "Color",
    "appearance": {
      "color": "Node color",
      "crop": "Crop Media with Shape",
      "border": "Border",
      "shadow": "Shadow",
      "media": "Media",
      "mediaUrl": "Add Media URL",
      "mediaSize": "Media Size",
      "opacity": "Opacity",
      "style": "Style"
    },
    "typography": {
      "textPosition": "Text Position",
      "paragraphSpacing": "Paragraph spacing, 'em' is relative to the font size of the paragraph."
    }
  },
  "objectTemplate": {
    "placeholder": "Choose Template",
    "label": "Update or Save New Object Template",
    "create": "Create New Template",
    "createShort": "Create Template",
    "update": "Update Template",
    "createdName": "Give your new template a name",
    "size": "Size:",
    "font": "Font:",
    "title": "Title",
    "nodeTemplates": "Node object templates",
    "edgeTemplates": "Edge object templates",
    "backButton": "Back to overview"
  },
  "sidebar": {
    "title": {
      "nodeDesign": "Edit Shape Design",
      "textDesign": "Edit Design of Text on Canvas",
      "nodeVisibility": "Manage Visibility of the Element",
      "edgeDesign": "Edit Edge Design",
      "edgeVisibility": "Manage Visibility of the Edge",
      "globalDesign": "Global Design Settings",
      "objectTemplates": "Object Templates",
      "mapSettings": "Basic Map Data"
    },
    "nodeDesign": {
      "clone": "Clone node",
      "delete": "Delete node",
      "placeholder": {
        "point": "New Point"
      },
      "label": {
        "name": "Name of the node",
        "shape": "Shape",
        "transformation": "Transformation",
        "appearance": "Appearance"
      },
      "title": {
        "appearance": "Shape Appearance",
        "typography": "Typography",
        "objectTemplate": "Object Template"
      }
    },
    "visibility": {
      "title": {
        "layers": "Visibility over all layers",
        "devices": "Visibility on different devices"
      },
      "label": {
        "first": "First Layer",
        "last": "Last Layer",
        "mobile": "Mobile",
        "tablet": "Tablet",
        "desktop": "Desktop"
      }
    },
    "edgeDesign": {
      "title": {
        "appearance": "Edge Appearance",
        "lettering": "Lettering"
      },
      "label": {
        "line": "Line Type",
        "lineStart": "Choose Line Start",
        "lineEnd": "Choose Line End",
        "start": "Label Text Start",
        "center": "Label Text Center",
        "end": "Label Text End"
      },
      "placeholder": {
        "text": "Add Label Text"
      }
    },
    "globalDesign": {
      "title": {
        "content": "Content Settings",
        "sections": "Additional Content Sections",
        "tooltip": "Tooltip Content",
        "table": "Table of Content"
      },
      "label": {
        "content": {
          "narrow": "Narrow Side Panel",
          "wide": "Wide Side Panel",
          "detachedLarge": "Detached Content Box large",
          "detachedSmall": "Detached Content Box small",
          "detachedMedium": "Detached Content Box medium"
        },
        "sections": {
          "info": "Additional Information",
          "nav": "Navigation"
        }
      }
    },
    "mapSettings": {
      "title": {
        "canvas": "Canvas",
        "bg": "Background",
        "behavior": "Node behavior in live view",
        "palette": "Color palette for controls",
        "download": "Download options",
        "assistant": "KAIA assistant"
      },
      "label": {
        "dimension": "Dimension",
        "expansion": "Expansion Direction",
        "zoom": "Zoom Levels",
        "bgFixed": "Fixed Background Image",
        "position": "Position",
        "repeat": "Repeat",
        "size": "Size",
        "transparency": "Transparency",
        "highlight": "Highlight read nodes",
        "tableOfContents": "Display table of contents",
        "searchEngine": "Display search engine",
        "darkMode": "Dark mode (suggested for bright backgrounds)",
        "brightMode": "Bright mode (suggested for dark backgrounds)",
        "nodesHighlights": "Highlight direct connections",
        "nodesList": "Show direct connections below content",
        "highlightBackdrop": "Background color when highlighting points",
        "modificationDate": "Display date of latest changes below content",
        "assistant": "Turn KAIA on for this map"
      },
      "button": {
        "exportContent": "Content of articles",
        "exportNodesContent": "Content of nodes",
        "exportGlossary": "Glossary terms",
        "exportSnapshot": "Map snapshot (last layer)",
        "exportMedia": "Media files"
      },
      "message": {
        "media": "Downloading all media files in progress. Depending on the amount and size of your library content this might take a while."
      },
      "tooltip": {
        "downloadInProgress": "Please wait until the data has been prepared for download"
      },
      "hint": {
        "assistant": "With KAIA off, the assistant is not offered while editing this map. It stays available in your other maps."
      }
    }
  },
  "common": {
    "soon": "Available soon",
    "duplicated": "You are already logged in!",
    "language": "Language"
  },
  "tooltip": {
    "editMap": "Edit Map Settings",
    "preview": "See Preview of Current Changes",
    "version": "Manage Versions",
    "mapOverview": "Access Map Overview",
    "generalSettings": "Manage General Settings",
    "knowledge": "Knowledge Base",
    "userSettings": "User Settings",
    "clients": "Clients",
    "logout": "Log Out",
    "noPermission": "You don't have access",
    "noAccess": "Not available in your subscription",
    "readPermission": "Please ask your admin \n to get editing access.",
    "adminPermission": "You need admin rights to access",
    "confirmTranslation": "To confirm the translation, check the box next to each language.",
    "languageBoardActive": "Use this button to switch between languages to quickly manage all translations. Advanced and comprehensive settings can be found in the content form.",
    "languageBoardInactive": "This is the ID of the chosen default language. Currently you didn't add an additional language. Please manage your language settings in the map specific settings.",
    "gifControlAnimation": "GIF Control Animation",
    "visitors": "People editing this map right now",
    "inviteMembers": "Invite team members",
    "mapProtocol": "Map protocol",
    "releaseNotes": "What is new"
  },
  "message": {
    "success": "Content successfully saved!",
    "mediaSuccess": "Content of {id} file successfully saved",
    "nodeCloneSuccess": "Node’s clone {id} has been created",
    "nodeCloneError": "Node’s clone created error occurred",
    "nodeCreatedSuccess": "Node {id} has been created",
    "nodeCreatedError": "Node created error occurred",
    "nodeRemovedSuccess": "Node {id} has been removed",
    "nodeRemovedError": "Node removed error occurred",
    "nodeDesignSuccess": "Node {id} design has been updated",
    "nodeDesignError": "Node {id} design updated error occurred",
    "nodeContentSuccess": "Node {id} content has been updated",
    "nodeContentError": "Node {id} content updated error occurred",
    "nodeVisibilitySuccess": "Node {id} visibility has been updated",
    "nodeVisibilityError": "Node {id} visibility updated error occurred",
    "nodeVisibilityRestored": "Node {id} visibility restored",
    "nodePositionSuccess": "Node’s position has been changed",
    "nodePositionError": "Node’s position changed error occurred",
    "nodesPositionsSuccess": "Nodes positions have been changed",
    "nodesPositionsError": "Nodes positions changed error occurred",
    "nodesOrderSuccess": "Nodes order has been changed",
    "nodesOrderError": "Error while changing nodes order",
    "nodeHiddenSuccess": "Node successfully hidden",
    "nodeHiddenError": "Node hidden error occurred",
    "nodeLockedSuccess": "Node successfully locked",
    "nodeLockedError": "Node locked error occurred",
    "layerHiddenSuccess": "Layer successfully hidden",
    "layerHiddenError": "Layer hidden error occurred",
    "layerLockedSuccess": "Layer successfully locked",
    "layerLockedError": "Layer locked error occurred",
    "templateApplySuccess": "Template applied successfully",
    "templateApplyError": "Error occurred while template applying",
    "templateRestoreSuccess": "Template restored successfully",
    "templateRestoreError": "Error occurred while template restoring",
    "templateCreateSuccess": "Template created successfully",
    "templateCreateError": "Error occurred while template creating",
    "templateNamedCreateSuccess": "Template {name} has been created",
    "templateNamedCreateError": "Error occurred while template {name} creating",
    "templateUpdateSuccess": "Template successfully updated",
    "templateUpdateError": "Error occurred while template update",
    "templateNamedUpdateSuccess": "Template {name} has been updated",
    "templateRemoveSuccess": "Template has been deleted",
    "templateRemoveError": "Error occurred while template deleted",
    "edgeCreateSuccess": "Edge {id} has been created",
    "edgeCreateError": "Edge created error occurred",
    "edgeRemoveSuccess": "Edge {id} has been removed",
    "edgeRemoveError": "Edge removed error occurred",
    "edgesRemoveSuccess": "All edges have been removed",
    "edgesRemoveError": "Edges related removed error occurred",
    "edgesRelatedRemoveSuccess": "Edges related have been removed",
    "edgesRelatedRemoveError": "Edges related removed error occurred",
    "edgeDesignSuccess": "Edge {id} design has been updated",
    "edgeDesignError": "Edge {id} design updated error occurred",
    "edgeContentSuccess": "Edge {id} content has been updated",
    "edgeContentError": "Edge {id} content updated error occurred",
    "edgeVisibilitySuccess": "Edge’s visibility has been updated",
    "edgeVisibilityError": "Edge’s visibility updated error occurred",
    "edgeVisibilityRestored": "Edge visibility restored",
    "globalUpdateSuccess": "Global design has been updated",
    "globalUpdateError": "Global design updated error occurred",
    "mapSettingsSuccess": "Map settings has been changed",
    "mapSettingsError": "Error occurred while changing map settings",
    "userLanguageSuccess": "Language has been changed",
    "userLanguageError": "Error occurred while changing language",
    "translatedUnchecked": "Please note! The confirmation boxes of additional languages have not been checked yet.",
    "translationsCare": "Please keep care of your translations",
    "downloadMediaSuccess": "Media files have been downloaded",
    "downloadMediaError": "Error occurred while downloading media files"
  },
  "shortcuts": {
    "title": "Keyboard shortcuts",
    "close": "Close",
    "hint": "Press ? to toggle this panel",
    "keys": {
      "ctrl": "Ctrl",
      "cmd": "⌘",
      "shift": "Shift",
      "enter": "Enter",
      "esc": "Esc",
      "del": "Delete",
      "space": "Space",
      "drag": "drag",
      "click": "click"
    },
    "groups": {
      "canvas": "Canvas",
      "title": "Point title",
      "help": "Help"
    },
    "items": {
      "delete": "Delete selected point(s)",
      "deselect": "Deselect all",
      "duplicate": "Duplicate point",
      "selectAll": "Select all points",
      "nudge": "Move point (Shift for larger steps)",
      "editTitle": "Edit point title",
      "pan": "Pan the map",
      "extendSelection": "Add / remove point from selection",
      "lasso": "Lasso-select points",
      "lineBreak": "Insert a line break",
      "nbsp": "Insert a non-breaking space",
      "softHyphen": "Insert a soft hyphen",
      "bold": "Toggle bold",
      "italic": "Toggle italic",
      "toggle": "Show / hide this panel"
    }
  },
  "quickEditBar": {
    "kaia": {
      "tooltip": "Generate content with your connected LLM",
      "tooltipFacts": "Generate key facts with your connected LLM",
      "tooltipReferences": "Generate references with your connected LLM",
      "unavailable": "No LLM is connected. Ask an administrator to connect one under API settings to generate content.",
      "failed": "Content generation failed. Connect an LLM under API settings or write the content manually."
    },
    "nav": "Add navigation:",
    "prev": "previous",
    "next": "next",
    "visibilityFrom": "Visibility from:",
    "visibilityOn": "Visibility on:",
    "linkNode": "Link node to:",
    "linkBlocked": "It’s not possible to link the node to an URL and provide content at the same time. In order to add a link please delete the content in the content form.",
    "textStart": "Text Start",
    "textEnd": "Text End",
    "moreOptions": "More options",
    "size": "Size",
    "fontColor": "Font Color",
    "contentNotSaved": "The content isn't saved.<br>Confirm your action:",
    "shapeSettings": "Shape Settings",
    "nodeAppearance": "Node Appearance",
    "fontSettings": "Font Settings",
    "titleShortcuts": "Shortcuts — Shift+Enter: line break, Ctrl+Shift+Space: non-breaking space, Ctrl+-: soft hyphen, Ctrl+B / Ctrl+I: bold / italic",
    "tooltips": {
      "noBold": "Bold not available",
      "noItalic": "Italic not available",
      "noBoldItalic": "There is no `Bold Italic` font"
    }
  },
  "popup": {
    "sidebar": {
      "title": {
        "content": "Manage Your Map Content",
        "web": "Manage the Web specific settings",
        "client": "Your Account Settings",
        "user": "User Settings",
        "map": "Map Settings"
      },
      "section": {
        "content": {
          "mediaAssets": "Media Assets"
        },
        "web": {
          "social": "Social Networks",
          "cookie": "Cookie Consent",
          "seo": "SEO",
          "url": "Map specific URL",
          "access": "Access restriction",
          "embed": "Embed Code"
        },
        "client": {
          "general": "General Settings",
          "user": "User Management",
          "analytics": "Analytics Settings",
          "api": "Manage API",
          "invoices": "Invoices",
          "billing": "Billing data",
          "subscription": "Manage subscription",
          "payment": "Payment settings"
        },
        "user": {
          "profile": "Profile",
          "password": "Password"
        },
        "map": {
          "settings": "General Map Settings",
          "versions": "Map Versions"
        },
        "templates": {}
      }
    },
    "testingPeriod": {
      "title": "Time flies!",
      "description": "Your free trial period for {package} has expired. Buy a license to keep working on your maps.",
      "package": {
        "singleLicense": "Single License"
      }
    },
    "askAdmin": {
      "title": "Contact your administrator",
      "description": "You don't have access to this feature. Please ask your administrator for help.",
      "button": "Contact admin",
      "message": {
        "success": "Message sent successfully!",
        "error": "Error occurred while sending message!"
      }
    },
    "choosingLang": {
      "title": "Choose your language:",
      "description": "Before launching your map please define which language you will start your project with.",
      "note": "You can add additional languages later in the general map settings.",
      "button": "Launch"
    },
    "translationsOverview": {
      "overview": {
        "title": "Overview and progress of translations",
        "table": {
          "text": "Texts to translate",
          "defaultLanguage": "Default language",
          "defaultLabels": "Default labels"
        },
        "message": {
          "warning": "Default labels are only available in English. Please add translations for default language."
        }
      },
      "labels": {
        "defaultLabels": {
          "title": "Default labels",
          "tooltip": "Default terms identify specific areas and sections in the live map."
        },
        "additionalSources": {
          "title": "Additional sources",
          "tooltip": "If additional sources are stored further to a BibTex file, they are separated from the others with the heading \"additional sources\"."
        },
        "bibtexSources": {
          "title": "Collection and overview of sources in a BibTeX file",
          "tooltip": "This heading is placed above a list of sources in the table of contents, which are extracted from a BibTeX file. When sources are uploaded with a BibTeX file, all the content they contain automatically appears in this list."
        },
        "editorsNote": {
          "title": "Editor's note",
          "tooltip": "This term is on a tab at the bottom of the map, which can be used to open an editorial with general information about the project."
        },
        "glossary": {
          "title": "Glossary",
          "tooltip": "If a glossary is kept, this term appears as a category in the table of contents. In it, all terms and their definitions are listed."
        },
        "interviewPartners": {
          "title": "Interview partners",
          "tooltip": "This term appears in the table of contents as soon as articles or media files have been marked as „interview partners“ with the corresponding shortcode. In it, all persons marked in this way are listed."
        },
        "listOfArticles": {
          "title": "List of articles",
          "tooltip": "This term describes a category of the table of contents in which all articles and subject aspects are listed."
        },
        "logIn": {
          "title": "Log in",
          "tooltip": "If the map has been published in a restricted environments, you must log in to it to access the content. "
        },
        "logOut": {
          "title": "Log out",
          "tooltip": "If you are logged in to a non-public map, you can log out here."
        },
        "searchAllResults": {
          "title": "all results",
          "tooltip": "In the map-internal search, the number of all results is displayed above the search results."
        },
        "searchNoResultsFound": {
          "title": "No results found",
          "tooltip": "If no results are found in the map-internal search, this default text appears."
        },
        "searchResultArticle": {
          "title": "Article",
          "tooltip": "In the map-internal search, the number of all search results is divided into subcategories more specifically. Articles shows all results that appear in articles, Media Files shows all results that appear in media."
        },
        "searchResultMap": {
          "title": "Map",
          "tooltip": ""
        },
        "searchResultMediaAsset": {
          "title": "Media",
          "tooltip": "In the map-internal search, the number of all search results is divided into subcategories more specifically. Articles shows all results that appear in articles, Media Files shows all results that appear in media."
        },
        "searchResultNode": {
          "title": "Info point",
          "tooltip": ""
        },
        "searchSeparateTermsByComma": {
          "title": "Separate terms by comma",
          "tooltip": "The search can be narrowed down further in the advanced search field. The placeholder text in the form fields gives an indication of how multiple terms should be entered."
        },
        "searchTerm": {
          "title": "Search term",
          "tooltip": "This term appears as a placeholder in the search field of the map-internal search."
        },
        "sources": {
          "title": "Sources",
          "tooltip": "If a source list is maintained, the category \"Sources\" appears in the table of contents"
        },
        "tableOfContents": {
          "title": "Table of contents",
          "tooltip": "This term appears as the parent headline in the table of contents."
        }
      }
    },
    "mapTemplates": {
      "projectName": "Give project a name",
      "create": "Create map",
      "createBlanc": "Create blank map",
      "createTemplate": "Create new template",
      "preview": "Preview",
      "selectTemplate": "Select Template",
      "selectWarningTop": "To choose this template",
      "selectWarningBottom": "please first create a live version",
      "editTemplate": "Edit Template",
      "deleteTemplate": "Delete Template",
      "templateName": "Give template a name",
      "cancel": "Cancel",
      "allTemplates": "All templates",
      "myTemplates": "My templates",
      "allTitle": "Start with a blank map or choose a template",
      "templatesTitle": "KontextMaps Templates",
      "templateTitle": "{type} templates",
      "templateCategories": "Template Categories",
      "learnMore": "Learn more",
      "useTemplate": "Use template",
      "themes": {
        "basic": "Basic",
        "process": "Process",
        "strategy": "Strategy",
        "business": "Business",
        "marketing": "Marketing",
        "personal": "Your personal",
        "my": "My"
      },
      "dimensions": "Dimensions:",
      "layers": "Layers:",
      "palette": "Color palette:",
      "section": "Section:"
    },
    "duplicate": {
      "doubleLogin": "Double Login!",
      "message": "Our system reports that you are already logged in to the Map Builder for this map with this user account. Have you opened this map in the Map Builder in another browser or another tab?",
      "back": " If yes: Please close that one.",
      "reload": " If not: Please reload this window.",
      "buttons": {
        "back": "Bring me back",
        "reload": "Reload page"
      }
    },
    "confirm": {
      "cannotUndone": "This cannot be undone.",
      "canUndo": "You can undo this with the undo button.",
      "youSure": "Are you sure?",
      "stopMe": "Oh no, please stop me!",
      "sure": "Yes, I’m 100% sure!",
      "warning": "You're about to {action} ",
      "quotaReached": "You have reached the maximum amount of {type}. Please contact us via: {email} to get more {type} or to upgrade your plan.",
      "quotaLiveMapsReached": "You have run out of live-maps. Deselect another project or upgrade your plan.",
      "quotaLiveMapsReachedAdmin": "You have run out of live-maps. Deselect another project or contact an administrator to upgrade your plan.",
      "quotaType": {
        "template": "templates",
        "map": "map projects"
      },
      "showMessage": "Don't show this message again (during current session).",
      "publishedMapDeleteWarning": "You're about to delete the live-map of this project. After that you will only keep the latest preview version of the map. Do you want to continue?",
      "noLiveVersion": "This map does not have a live version. Please, select it as a live map first in the Map Overview.",
      "actions": {
        "deleteClient": "delete a client.",
        "deactivateClient": "deactivate a client.",
        "deleteMap": "delete a map.",
        "deleteNode": "delete a node.",
        "deleteLayer": "delete a layer.",
        "deleteEdge": "delete an edge.",
        "deleteEdges": "delete all the edges.",
        "deleteAsset": "delete an asset.",
        "resetMap": "reset map.",
        "deselectProject": "Deselect other project",
        "upgradePlan": "Upgrade plan",
        "deleteLiveMap": "Yes! Delete it!",
        "keepLiveMap": "Oh no! Hold me back!",
        "confirm": "Let's do this",
        "cancel": "Maybe later",
        "deleteRelatedEdges": "Confirm and delete edges",
        "cancelDeleteRelatedEdges": "Noooooooooo!!!",
        "deletePackage": "delete a package."
      },
      "tocWarning": "This node is included in the Table of Contents individual order.",
      "deleteAndManageToc": "Delete & Manage in TOC",
      "tocDeletedNodesAlert": "Attention required: Some nodes in the individual order have been deleted and need to be managed.",
      "largeScreens": "The Map Builder is optimized for editing on larger screens. A limited mobile version will be released soon.",
      "switchScreen": "To create, edit and manage your maps please switch to a larger screen.",
      "deleteEdgesNotOverlappedMessage": "Layer conflict! One or more connecting edges to the point which layer settings you are about to change, would no longer be connected to that point and would run into the void.",
      "liveMapSeats": {
        "title": "All live map seats taken.",
        "options": "You have two options:",
        "overview": "1. go to the map overview and deactivate the live status of another project, or",
        "upgrade": "2. write to our sales team to upgrade your license.",
        "upgradeViaAdmin": "2. write to an administrator to extend the license.",
        "buttons": {
          "overview": "Map overview",
          "sales": "Contact sales",
          "admin": "Contact admin"
        }
      }
    },
    "content": {
      "title": "Content Form",
      "desc": "Find here the overview of all nodes on the map and its content.",
      "label": {
        "node": "Node",
        "title": "Title",
        "type": "Type of Content Box",
        "typeShort": "Content Box",
        "link": "Direct link",
        "content": "Content",
        "info": "Additional Information",
        "nav": "Navigation below the Content Area:",
        "prevNode": "Previous Node",
        "nextNode": "Next Node",
        "terms": "Search terms",
        "seo": "Short Description of the Content for SEO"
      },
      "placeholder": {
        "title": "Popup title",
        "url": "Add URL",
        "terms": "Search terms separated with commas",
        "seo": "Add here a short description with a maximum of 250 characters."
      },
      "button": {
        "save": "Save node’s content",
        "translate": "Translate with DeepL",
        "discard": "Discard and leave"
      },
      "message": {
        "error": "Error occurred while changing node content!",
        "unsaved": "You didn’t save yet. If you don’t save you will lose your changes. Are you sure you want to leave?"
      },
      "sources": {
        "label": "Source documents",
        "hint": "Text generated for this point is based on these documents. Readers never see them, and they are never cited.",
        "none": "No document is attached to this point yet.",
        "attach": "Attach a file",
        "attachLink": "Attach a link",
        "linkLabel": "Address of the page to attach",
        "linkPlaceholder": "https://…",
        "addLink": "Attach",
        "cancel": "Cancel",
        "remove": "Delete {name}",
        "confirmRemove": "Delete {name}?",
        "delete": "Delete",
        "untitled": "Attached document",
        "reading": "Reading the document…",
        "failed": "This document could not be read.",
        "fromDeletedPoint": "From a deleted point",
        "actionFailed": "That did not work. Please try again.",
        "unavailable": "No LLM is connected. Ask an administrator to connect one under API settings to use documents.",
        "title": "Source documents of this point",
        "close": "Close"
      }
    },
    "editors": {
      "title": "Editor’s Note",
      "desc": "Add additional information about your map project via an editor’s note.",
      "team": "Introduce your team members",
      "label": {
        "title": "Title",
        "editors": "Editor’s note",
        "name": "Name",
        "desc": "Description",
        "label": "Label",
        "togglerLabel": "Status"
      },
      "placeholder": {
        "title": "e.g. Editor’s note and team",
        "desc": "Short description text",
        "label": "Label on the map"
      },
      "button": {
        "add": "Add team member",
        "save": "Save editor’s note"
      },
      "message": {
        "errorLoading": "Error occurred while loading settings!",
        "errorSave": "Error occurred while changing settings!",
        "success": "Settings successfully changed!"
      }
    },
    "glossary": {
      "title": "Glossary",
      "desc": "Explain selected terms of your map project, for a better understanding.",
      "label": {
        "term": "Term",
        "alternative": "Alternative versions",
        "synonyms": "Synonyms",
        "definition": "Definition"
      },
      "placeholder": {
        "term": "Term to be defined",
        "alternative": "Semi-colon separated; does not appear in glossary list",
        "synonyms": "Semi-colon separated",
        "definition": "Definition text"
      },
      "button": {
        "add": "Add new terms",
        "save": "Save glossary settings"
      },
      "message": {
        "errorLoading": "Error occurred while loading glossary settings!",
        "errorSave": "Error occurred while changing glossary settings!",
        "success": "Settings saved successfully!"
      }
    },
    "references": {
      "title": "List of References",
      "titleShort": "Sources",
      "desc": "Show the sources of your research in a list of references",
      "label": {
        "name": "Source name",
        "link": "Link"
      },
      "placeholder": {
        "name": "Source name",
        "link": "Reference to source"
      },
      "button": {
        "add": "Add new source",
        "save": "Save list of sources",
        "upload": "Upload BibTeX file"
      },
      "message": {
        "errorLoading": "Error occurred while loading sources!",
        "errorSave": "Error occurred while changing list of references!",
        "success": "Settings saved successfully!",
        "successFile": "File uploaded successfully!",
        "errorFile": "Error occurred while file uploading!",
        "successFileProblems": "File uploaded. The map shows some references differently from the file – see the warning beside it."
      },
      "problems": {
        "summary": "The map shows {count} reference differently from the file: | The map shows {count} references differently from the file:",
        "missing_field": "{entry}: the field “{field}” is missing, so it is shown in a shortened form",
        "empty": "{entry}: has no title, author or other field the map can show, so it is left out",
        "not_formatted": "{entry}: could not be formatted, so it is left out",
        "other": "{entry}: {message}",
        "more": "… and {count} more",
        "unreadable": "The file cannot be read, so the map shows no references. Please upload a corrected file. Details: {message}"
      }
    },
    "header": {
      "title": "Header bar",
      "desc": "Add an individual header bar to your map project",
      "design": {
        "bg": "Background",
        "height": "Header height",
        "logo": "Logo",
        "logoHeight": "Logo height in header bar",
        "link": "Logo link URL",
        "color": "Font color"
      },
      "label": {
        "title": "Title",
        "url": "URL",
        "target": "Target window",
        "design": "Design Settings",
        "floating": "Free floating links",
        "additional": "Additional links"
      },
      "placeholder": {
        "title": "Visible Title",
        "url": "Please enter the URL",
        "link": "URL of website"
      },
      "options": {
        "new": "New window",
        "same": "Same window / IFrame",
        "embed": "Window embedding the map"
      },
      "button": {
        "addAdditional": "Add additional link",
        "addFloating": "Add floating link",
        "save": "Save header settings"
      },
      "message": {
        "success": "Settings successfully changed!",
        "errorSave": "Error occurred while changing header bar settings!",
        "errorLoading": "Error occurred while loading header bar settings!",
        "warningRestore": "You are about to restore map version to previous one. Are you sure you want to continue?"
      }
    },
    "tableOfContent": {
      "title": "Table of Contents",
      "desc": "Manage here all the parts of the table of content",
      "subTitle": "Subcategories of the table of content:",
      "label": {
        "show": "show",
        "individual": "individual order"
      },
      "articles": {
        "desc1": "Move the article from the right column into the ",
        "desc2": "left column",
        "desc3": "and organize them by dragging and dropping. You can create up to four hierarchy levels.",
        "individual": "Individual order of your table of contents",
        "unsorted": "Unsorted articles"
      }
    },
    "media": {
      "title": "Media Assets",
      "titleTemplates": "Media Templates",
      "titleDetails": "File information:",
      "label": {
        "templates": "File templates",
        "container": "In which container/s will this file be displayed?",
        "small": "Narrow side panel",
        "wide": "Wide side panel",
        "detached": "Detached content box",
        "icon": "Map icon",
        "bg": "Background image",
        "desc": "What describes your file best?",
        "photo": "Photography",
        "portrait": "Portrait",
        "graphic": "Infographic",
        "drawing": "Drawing",
        "illustration": "Illustration",
        "animation": "Animation",
        "film": "Film",
        "voice": "Voice",
        "music": "Music",
        "author": "Author/Creator",
        "title": "Title",
        "contact": "Contact Information",
        "copyright": "Copyright",
        "dateCreation": "Creation Date",
        "authorText": "Text for author byline",
        "summary": "Short summary",
        "keywords": "Keywords",
        "searchTerms": "Search terms (keywords prioritized in search)",
        "datePublication": "Publication date",
        "source": "Source",
        "categories": "Categories (pre-defined hierarchy)"
      },
      "placeholder": {
        "author": "Add Name",
        "title": "Add Title",
        "contact": "Add Information",
        "copyright": "Add Copyright",
        "dateCreation": "YYYY-MM-DD HH:MM:SS",
        "authorText": "Type here",
        "summary": "Type here",
        "keywords": "Add keywords",
        "searchTerms": "Add search terms",
        "voice": "Add text",
        "datePublication": "YYYY-MM-DD HH:MM:SS",
        "source": "Add text",
        "categories": "Add text",
        "categoriesTranslate": "Add translation"
      },
      "button": {
        "upload": "Upload new file",
        "back": "Back to overview",
        "copy": "copy Media URL",
        "update": "Update information",
        "uploadFile": "Upload file"
      },
      "message": {
        "errorUpload": "Something went wrong!",
        "update": "Updated successfully",
        "paste": "Chosen image url ready to paste",
        "errorLoading": "Something went wrong. Please try again!",
        "sizeExceeded": "File size exceeded!",
        "invalidLottie": "This JSON file is not a valid Lottie animation.",
        "categoryCreateError": "The category could not be created."
      },
      "upload": {
        "overview": "Overview of maximum file sizes",
        "fileLimit": "max {size}Mb per file.",
        "noLimit": "no limits",
        "video": "Video files",
        "videoOptimal": "Optimal file settings: Render with HEVC (H.265) format",
        "images": "Images",
        "vector": "Vector based web format",
        "audio": "Audio formats",
        "other": "All other files"
      }
    },
    "mediaList": {
      "header": {
        "name": "Name of the files",
        "check": "File check"
      },
      "message": {
        "accepted": "Ready to upload",
        "denied": "The file size is too big.\n This file won't be uploaded."
      },
      "uploadButton": "Upload files"
    },
    "social": {
      "title": "Share icons",
      "desc": "Choose your sharing menu. All selected options automatically appear as buttons on your map.",
      "message": {
        "errorLoading": "Error occurred while loading social network settings!",
        "errorSave": "Error occurred while changing social network settings!",
        "success": "Settings successfully changed!"
      }
    },
    "cookie": {
      "title": "Cookie Consent",
      "desc": "Add a cookie consent to your map project.",
      "label": {
        "activate": "Activate cookie consent",
        "essentialLabel": "Necessary Cookies",
        "essentialDescription": "Essential Description",
        "externalLabel": "Allow external sources",
        "externalDescription": "External media description",
        "statisticsLabel": "Statistics",
        "statisticsDescription": "Statistics Description",
        "imprintLabel": "Imprint URL",
        "policyLabel": "Data Privacy Rules URL"
      },
      "placeholder": {
        "link": "Link your own data protection policy. If you leave it empty, the standard Kontextlab policy will be connected."
      },
      "message": {
        "success": "Settings successfully changed!",
        "errorLoading": "Error occurred while loading cookie consent settings!",
        "errorSave": "Error occurred while changing cookie consent settings!"
      }
    },
    "seo": {
      "title": "SEO",
      "desc": "Add an additional description to your project to help search engines find your project.",
      "label": {
        "desc": "Description",
        "url": "URL for embedded Maps"
      },
      "info": {
        "url1": "For search engine optimization it is important to choose the correct URL when publishing the map. The available URLs can be copied from the Publish page.",
        "url2": "However, it should be noted that embedding such a URL via IFrame or embed code has a negative effect on search engine optimization.",
        "url3": "For an optimized search result, using the original or a CNAME domain is the best option."
      },
      "placeholder": {
        "desc": "Short description of your map project. Ideally 120 – 160 characters.",
        "url": "URL of the final page, where the map will be embedded"
      },
      "message": {
        "success": "Settings successfully changed!",
        "errorLoading": "Error occurred while loading seo settings!",
        "errorSave": "Error occurred while changing seo settings!"
      }
    },
    "url": {
      "title": "Map specific URL",
      "desc": "Copy the URL of the project or customize it with an individual identifier.",
      "label": {
        "usage": "Usage on",
        "usageSub": "Usage on customer subdomain",
        "usageCNAME": "Usage via CNAME URL",
        "url": "URL Identifier"
      },
      "info": {
        "default": "Your default map URL",
        "personalized": "Your personalized map URL",
        "manageSubdomain": "You can manage the subdomain of this individual URL in the",
        "customizeID": "Customise the individual URL identifier for this project (this is the specific identifier at the end of the URL).",
        "defaultID": "The <span class=\"font-weight--500\">{id}</span> is used here as the default identifier:",
        "urlCustom": "The last part of the URL can be customized further down in the field \"URL Identifier\"",
        "usageSub": "As an alternative, shorter URL variant, a customer-specific URL can also be used, which is provided on",
        "usageCNAME": "Public maps use this URL to optimize them for search engines. All maps that should not be public must use an alternative URL to make use of the access restriction.",
        "noSubdomain": {
          "createOptions": "Create an individual and shortened URL for your map. Depending on the package, you have two options:",
          "subdomain": "1. an individual kontextmaps subdomain",
          "or": "or",
          "cname": "2. a transfer of the map to your own domain or subdomain via CNAME.",
          "note": "Please note: Only one of these two options can be set up at a time. The individual domain settings apply to all map projects in your account. Set up the URL identifier individually for each map project.",
          "noURL": "There is no individual URL setting yet. Select one of the two options in the",
          "linkSettings": "general account Settings",
          "setURL": "You can then set the individual URL identifier for this project here:"
        }
      },
      "placeholder": {
        "url": "Specify an URL"
      },
      "message": {
        "success": "Settings successfully changed!",
        "errorLoading": "Error occurred while loading url details settings!",
        "errorSave": "Error occurred while changing map url settings!",
        "paste": "Link copied to clipboard!",
        "errorPaste": "Cannot be copied to clipboard! Please do that manually."
      }
    },
    "access": {
      "title": "Access restriction",
      "desc": "Decide whether your map project is publicly accessible or only accessible to certain groups.",
      "options": {
        "limited": "limited access",
        "partial": "partially limited access",
        "accessible": "publicly accessible"
      },
      "label": {
        "access": "Access restriction",
        "additional": "Additional restrictions",
        "callEmbedded": "Only callable when embedded",
        "clickablePoints": "Number of clickable popup points",
        "loginForm": "Text for the login form",
        "registerForm": "Text for the register form",
        "consent": "Text for consent at registration",
        "consentRequired": "Consent at registration is required",
        "allowEmbedded": "Allow embedded domains"
      },
      "placeholder": {
        "allowEmbedded": "One domain or subdomain per line, e. g.\nexample.com or kontext.example.com"
      },
      "message": {
        "success": "Settings successfully changed!",
        "errorLoading": "Error occurred while loading access restrictions settings!",
        "errorSave": "Error occurred while changing access restrictions settings!"
      }
    },
    "embed": {
      "title": "Embed Code",
      "desc": "Embed your map project on your existing website.",
      "label": {
        "iframe": "To embed the map on your website via iFrame, please copy the following complete code snippet:",
        "preview": "You can also embed the map with a preview image. The preview image will appear in your website and if you click on it, the map will open in the browser window. To do this, please first load your preview image into the media management with the image name preview.jpg or preview.png. Then copy the following code and paste it into your website:"
      },
      "message": {
        "paste": "Link copied to clipboard!",
        "errorLoading": "Error occurred while loading embed code settings!",
        "errorPaste": "Cannot be copied to clipboard! Please do that manually."
      }
    },
    "general": {
      "title": "General Settings",
      "desc": "Edit the profile and the general domain settings.",
      "label": {
        "profile": "Profile",
        "company": "Company Name",
        "logo": "Logo",
        "logoText": "Login Page text",
        "domain": "Domain settings",
        "cname": "CNAME Domain",
        "subdomain": "Your KontextMaps Subdomain"
      },
      "info": {
        "settings": "Manage your individual and shortened main domain here, which applies to all your map publications.",
        "settingsNote": "Please note: Only one of these two options can be set up at a time.",
        "cname": "Create an individual subdomain at your webhoster’s system and set the domain settings to CNAME and allow Kontextlab the access.",
        "subdomain": "Be aware that editing the subdomain is going to break already shared URLs, invalidating them for future use."
      },
      "placeholder": {
        "company": "Name",
        "cname": "Add your individual CNAME connected domain e.g. cname.com",
        "subdomain": "e.g. subdomain"
      },
      "button": {
        "upload": "Upload Portrait"
      },
      "message": {
        "success": "Settings successfully changed!",
        "errorLoading": "Error occurred while loading general domain settings!",
        "errorSave": "Error occurred while changing general domain settings!"
      }
    },
    "profile": {
      "title": "Profile",
      "desc": "Manage your individual profile.",
      "label": {
        "firstName": "First Name",
        "surname": "Surname",
        "email": "Email address",
        "picture": "Profile picture"
      },
      "placeholder": {
        "firstName": "Name",
        "surname": "Name",
        "email": "Email address"
      },
      "button": {
        "upload": "Upload Portrait"
      },
      "message": {
        "success": "Profile successfully changed!",
        "errorSave": "Error occurred while changing profile settings!"
      }
    },
    "password": {
      "title": "Password",
      "desc": "Manage your password.",
      "label": {
        "password": "Password",
        "confirm": "Password confirmation"
      },
      "placeholder": {
        "password": "At least 8 characters",
        "confirm": "Confirm your password"
      },
      "message": {
        "success": "Password successfully changed!",
        "errorSave": "Something went wrong"
      }
    },
    "mapGeneral": {
      "title": "General Map Settings",
      "desc": "Manage the general information of your map project.",
      "settingsTitle": "Individual settings for live map view",
      "label": {
        "project": "Name of the Map Project",
        "desc": "Description",
        "terms": "Search terms",
        "section": "Section",
        "palette": "Color palette",
        "preview": "Preview picture",
        "favicon": "Favicon",
        "premium": "Premium template",
        "templateDescription": "Short Description of the Template",
        "templateDescriptionUrl": "URL to detailed template description (optional)",
        "templateCategory": "Template category"
      },
      "placeholder": {
        "project": "Name of the map",
        "desc": "Short description of the map content",
        "terms": "Search terms separated with commas",
        "section": "e.g. business",
        "palette": "e.g. ocean",
        "templateDescription": "Short description of the map template, max 150 characters",
        "templateDescriptionUrl": "URL to external template description"
      },
      "message": {
        "success": "Settings successfully changed!",
        "errorSave": "Error occurred while changing general map settings!"
      },
      "button": {
        "favicon": "Upload Favicon",
        "preview": "Upload Preview"
      },
      "uploadDescription": {
        "notes": "Notes for favicon image upload:",
        "dimensions": "Image dimension: square",
        "size": "Image size: between 128x128px and 512x512px",
        "format": "File format: .jpg or .png"
      }
    },
    "mapVersion": {
      "title": "Live version",
      "titleProgress": "Map in progress",
      "label": {
        "publish": "Publish the most recent version here.",
        "lastPublished": "Last modified on",
        "notPublished": "Live version not published yet",
        "changed": "The map has changed.",
        "lastLive": "Last live version published on"
      },
      "button": {
        "viewProgress": "View map in progress",
        "reset": "Reset map progress",
        "sync": "Sync to live version",
        "viewLive": "View live version"
      },
      "message": {
        "successPublished": "Map successfully published!",
        "errorPublished": "Error occurred during map publishing!",
        "successReset": "Map successfully reset!",
        "errorReset": "Error occurred during map reset!"
      }
    },
    "publishing": {
      "title": "Publish your map",
      "desc": "Find here a step by step guide to publish and share your map",
      "tooltip": "Publish Overview",
      "blockedOptionTooltip": "The live-map is mandatory in order to modify these options.",
      "steps": {
        "create": {
          "title": "Create live version",
          "description": "To publish your map, you need to create a live version. This version is different from the preview version: it doesn’t contain a „preview“ label and will show all further changes only when you actively upload it there. You can manage the versions of your map ",
          "descriptionLink": "here.",
          "status": {
            "notPublished": "This map project does not have a live version yet. Now create a live version of this project to proceed with publishing.",
            "hasChanges": {
              "changes": "A live version exists for this map project. However, changes have been made.",
              "check": "Please check ",
              "link": "Map Versions",
              "upload": "to see if you want to upload these changes to the current live version.",
              "access": "Or continue with the ",
              "accessLink": "access management."
            },
            "exist": "A live version exists for this map project. The live map is up to date.",
            "existLink": "Now manage the access for this map."
          },
          "popup": {
            "noLiveVersionTitle": "No live version available",
            "studentContent": "In order to publish the map project a live version is mandatory. This can only be created by administrators or editors. So please contact your admin to get a valid URL."
          },
          "button": {
            "publish": "Publish as live version"
          }
        },
        "access": {
          "title": "Manage access",
          "descStudent": "Administrators can decide whether the live map is accessible to the public or only to a selected group.",
          "projectAccess": "This project currently has"
        },
        "publish": {
          "title": "Publish your map",
          "desc": "Choose one of the three options to share and publish your map:",
          "options": {
            "default": {
              "title": "1. The default URL",
              "desc": "Each map automatically receives a URL. This is always valid, regardless of the other options. If your map is not public, invited visitors must log in via a login page to access the map.",
              "url": "Your default URL:"
            },
            "custom": {
              "title": "2. Your custom domain",
              "descAdmin": "To shorten the URL and to assign a unique identifier to it, you can either set up an individual KontextMaps subdomain or transfer the map via CNAME domain to your personal domain.",
              "admin": {
                "manage": "Manage the",
                "subdomain": "subdomain here",
                "and": "and the",
                "id": "map identifier here."
              },
              "descStudent": "To make the URL shorter and to assign a unique identifier to it, an administrator can set up an individual domain. If you want to make changes, ",
              "descStudentLink": "please ask your admin.",
              "url": "The individual URL of the map is:",
              "noUrl": "Currently no individual domain is set up."
            },
            "embed": {
              "title": "3. Embed into your website",
              "desc": "Embed the map directly into your website using an iFrame. Alternatively, you can include a preview image (choose the div tag variant for this), on which the map is opened in full format with a click.",
              "link": "Find all embedding codes here."
            }
          }
        }
      }
    },
    "mapLanguages": {
      "title": "Map Language Settings",
      "desc": "Manage the language settings this map and find an overview of all translations.",
      "preview": {
        "title": "Language settings for preview and live map",
        "radio": {
          "auto": "automatic (like browser language)",
          "default": "default language"
        },
        "label": {
          "first": "What language should be displayed first?",
          "default": "Which is the default language?",
          "additional": "Which additional languages do you want to add?",
          "translateWith": "Translate with",
          "integration": "Select translation integration",
          "apiKey": "Your API-key"
        },
        "placeholder": {
          "additional": "Additional languages",
          "provider": "Translation providers..",
          "apiKey": "Saved; leave blank to keep the current key"
        }
      },
      "button": {
        "globalTranslation": "Translate the entire map"
      },
      "tooltip": {
        "translated": "All texts translated",
        "notTranslated": "All or some texts are not translated yet. Please check the translations.",
        "notTranslatedDefault": "Default labels are only available in English. Please add translations for default language."
      },
      "message": {
        "targetLanguagesError": "Additional languages {languages} are not supported by DeepL. Please ensure you translate them manually.",
        "targetLanguageError": "Additional {language} language is not supported by DeepL. Please ensure you translate it manually.",
        "partialTargetLanguagesError": "{languages} of additional languages are not supported by DeepL. Please ensure you translate them manually.",
        "partialTargetLanguageError": "{language} of additional languages is not supported by DeepL. Please ensure you translate it manually.",
        "sourceLanguageError": "{language} language is not supported by DeepL",
        "credentialsError": "Please check your credentials or try again later."
      }
    },
    "mapProtocol": {
      "title": "Protocol",
      "desc": "Find here all the latest changes of your map project and restore previous states if needed.",
      "label": {
        "version": "Version-ID",
        "date": "Date",
        "time": "Time",
        "editedBy": "Edited by",
        "typeOfChange": "Type of change",
        "restoreState": "Restore state"
      }
    },
    "collectedVersions": {
      "title": "Collected Versions",
      "save": "Save current map state",
      "publishLive": "Publish version as live-version",
      "label": {
        "version": "Version-ID",
        "date": "Date",
        "time": "Time",
        "saved": "Saved by",
        "name": "Name of Version",
        "describe": "Describe map state"
      },
      "message": {
        "error": "Error occurred"
      }
    },
    "mapSpecific": {
      "access": {
        "none": "No Access",
        "read": "Read",
        "edit": "Read and Edit"
      },
      "button": {
        "save": "Save map settings"
      }
    },
    "user": {
      "title": "User Accounts",
      "desc": "Manage all users of your map projects.",
      "label": {
        "name": "Full name",
        "email": "Email Address",
        "role": "Role",
        "password": "Password",
        "passwordConfirm": "Password confirmation",
        "premium": "This is a premium template"
      },
      "placeholder": {
        "name": "Add name",
        "email": "Add email address",
        "password": "At least 8 characters",
        "passwordConfirm": "Confirm your password"
      },
      "button": {
        "add": "Add new user",
        "save": "Save user settings",
        "remove": "Delete user",
        "removeCancel": "I've changed my mind"
      },
      "support": {
        "desc": "Manage access for the KontextMaps support team",
        "checkbox": "I grant the support team access to my account and projects in order to get help"
      },
      "message": {
        "removeUser": "Continue deleting the user?",
        "inviteAll": "Please invite all users before saving",
        "success": "User accounts changed successfully!",
        "errorSave": "Error occurred while changing user accounts settings!",
        "errorLoading": "Error occurred while loading user accounts settings!",
        "emailExists": "A password already exists for this email address. If you enter a new one, it will automatically be used for all other accounts connected to this email address.",
        "quotaReached": "You've reached the limit of available seats. To extend it, please choose the right package."
      }
    },
    "analytics": {
      "title": "Analytics Settings",
      "desc": "Connect the map to your analytics account.",
      "label": {
        "code": "Analytics code"
      },
      "placeholder": {
        "code": "Google Property ID"
      },
      "message": {
        "success": "User accounts changed successfully!",
        "errorSave": "Error occurred while changing analytics settings!",
        "errorLoading": "Error occurred while loading analytics settings!"
      }
    },
    "api": {
      "title": "Manage API",
      "desc": "Connect external sources with your KontextMap account.",
      "label": {
        "key": "API Key",
        "address": "Server Address"
      },
      "placeholder": {
        "key": "Enter here your API key",
        "address": "Enter here the server address",
        "keyStored": "Stored — enter a new value to replace it"
      },
      "button": {
        "save": "Save API settings",
        "test": "Test connection"
      },
      "ownModel": {
        "title": "Own LLM",
        "desc": "Connect your own language model to generate article content for map points.",
        "noneOption": "Not connected",
        "label": {
          "provider": "Provider",
          "model": "Model",
          "endpoint": "Endpoint",
          "apiVersion": "API version",
          "key": "API Key"
        },
        "placeholder": {
          "provider": "Select a provider",
          "model": "e.g. gpt-4o, mistral-large-latest",
          "endpoint": "Server base URL",
          "apiVersion": "e.g. 2024-10-21",
          "key": "Enter the model provider's API key",
          "keyOptional": "Optional for on-premise servers"
        },
        "button": {
          "save": "Save LLM settings"
        }
      },
      "field": {
        "api_key": "API key",
        "api_token": "API token",
        "client_id": "Application (client) ID",
        "client_secret": "Client secret",
        "deployment": "Deployment",
        "email": "Account email",
        "integration_token": "Internal integration token",
        "permission_scope": "Permission scope",
        "server_url": "Server address",
        "site_url": "Site URL",
        "space_key": "Space key",
        "tenant_id": "Directory (tenant) ID"
      },
      "fieldPlaceholder": {
        "email": "bot{'@'}acme.example",
        "site_url": "https://acme.sharepoint.com/sites/engineering",
        "space_key": "e.g. ENG"
      },
      "help": {
        "api_token": "Cloud: an Atlassian API token. Data Center: a personal access token.",
        "client_id": "Entra ID → App registrations → your app → Overview → Application (client) ID. The registration needs the application permission chosen below, granted with admin consent.",
        "client_secret": "Entra ID → App registrations → your app → Certificates & secrets → New client secret. Copy the Value, not the Secret ID. SharePoint itself has no API key.",
        "email": "The Atlassian account the API token belongs to.",
        "integration_token": "Create an internal integration at notion.so/my-integrations and paste its secret here. Then, in Notion, share each page you want to offer with that integration through the page menu, under Connections: **a working token shows nothing until something has been shared with it.**",
        "permission_scope": "Sites.Read.All lets this app read **every site in the tenant**, not only the one configured here — the site URL narrows what this connection shows, not what the app may read. Sites.Selected grants nothing by default: a SharePoint administrator then grants read access to individual sites. Prefer it unless search across a large site is needed — it reads the site directly, so it cannot use the tenant search index and reports no result count.",
        "site_url": "The site to read, e.g. https://acme.sharepoint.com/sites/engineering — the address of the site itself, not of a page in it.",
        "space_key": "Only pages in this space are offered. The key is the short code in the space URL, e.g. /wiki/spaces/ENG — not an API token.",
        "tenant_id": "Entra ID → App registrations → your app → Overview → Directory (tenant) ID."
      },
      "choice": {
        "deployment": {
          "cloud": "Atlassian Cloud",
          "datacenter": "Data Center / Server (self-hosted)"
        },
        "permission_scope": {
          "sites_read_all": "Sites.Read.All — every site in the tenant",
          "sites_selected": "Sites.Selected — only sites granted one by one"
        }
      },
      "noneEnabled": "No external source has been enabled for this account yet.",
      "message": {
        "incomplete": "{provider} was not saved: fill in {fields}.",
        "looksLikeSecret": "{provider} was not saved: “{field}” contains what looks like an API token. The token belongs in the credential field of this source.",
        "testRunning": "Testing the connection…",
        "testTotal": "Connected — {total} items available.",
        "testSome": "Connected — content was returned.",
        "testEmpty": "Connected, but the source returned nothing. Check the space key or site URL.",
        "testSample": "First item: “{title}”.",
        "testNotEnabled": "The credentials work. {provider} still has to be enabled for this account before the source appears in the Map Builder.",
        "testFailed": "The test failed."
      },
      "connection": {
        "label": "Connection name",
        "placeholder": "e.g. Engineering wiki",
        "add": "Add another connection",
        "create": "Add connection",
        "save": "Save connection",
        "cancel": "Cancel",
        "remove": "Disconnect",
        "removeConfirm": "Disconnect for good",
        "removeHint": "Content already embedded from this connection stops resolving, and the name is never reused.",
        "labelRequired": "Give the connection a name: it is the only thing telling two connections of one source apart.",
        "added": "“{label}” was added to {provider}.",
        "saved": "“{label}” was saved.",
        "removed": "“{label}” was disconnected from {provider}.",
        "perConnection": "Each connection of this source is saved on its own."
      },
      "assistant": {
        "title": "KAIA assistant",
        "desc": "KAIA guides authors through building a map. Switch it off to hide it from every map of this account; authors can also switch it off for a single map in that map’s general settings.",
        "label": "Turn KAIA on for this account"
      }
    },
    "reports": {
      "title": "Analytics Reports",
      "desc": "Connect the map to your analytics account."
    },
    "invoices": {
      "title": "Invoices",
      "desc": "Find here a list to your invoices.",
      "message": {
        "errorLoading": "Error occurred while loading invoices details!"
      }
    },
    "billing": {
      "title": "Billing data",
      "desc": "Update the data for your invoice here.",
      "label": {
        "company": "Company Name",
        "email": "Email address",
        "address": "Address",
        "postal": "Postal code",
        "city": "City",
        "state": "State",
        "country": "Country",
        "id": "Sales tax ID no."
      },
      "placeholder": {
        "company": "Name",
        "email": "Add email address",
        "address": "Name of the Street",
        "postal": "12345",
        "city": "Name of the city",
        "state": "Name of the state",
        "id": "DE123456789"
      },
      "message": {
        "success": "Settings successfully changed!",
        "errorSave": "Error occurred while changing billing settings!",
        "errorLoading": "Error occurred while loading billing settings!"
      }
    },
    "subscription": {
      "title": "Manage subscription",
      "desc": "Overview of your current license",
      "overview": {
        "plan": "Your current plan:",
        "extension": "Your plan extensions:",
        "start": "Your license started at:",
        "renew": "Your license will be automatically renewed at:"
      },
      "manage": {
        "title": "Manage current license and related data",
        "desc": "Please enter the self service portal from our payment provider in order to:",
        "list": {
          "adjust": "Adjust your invoice data",
          "manage": "Manage payment data",
          "cancel": "Cancel license"
        },
        "button": "Enter self service portal"
      },
      "order": {
        "title": "Order extensions",
        "desc": "Please choose from the following options to upgrade your license. Billing (annual/monthly) follows the billing period of your main licence.",
        "extension": {
          "mapCreator": "Additional map creator (admin or editor)",
          "liveMap": "Additional live map",
          "storage": "Additional 5GB media-storage"
        },
        "month": "month",
        "button": "Buy extension"
      },
      "confirm": {
        "title": "You are about to buy the following license extensions:",
        "desc": {
          "restart": "With the purchase of the extensions, the term of your license restarts today:",
          "license": "Therefore, along with the extensions, the license for your current license will also be recalculated. The already paid license fees of the original remaining term will be deducted from the total amount."
        },
        "total": {
          "period": "Billing period:",
          "extension": "Total license extension,",
          "plan": "Total license plan (plan name),",
          "term": "Less remaining term of the current license"
        },
        "period": {
          "month": "monthly",
          "year": "yearly"
        },
        "invoice": "Thus, the total invoice amount is:",
        "button": "Upgrade plan"
      }
    },
    "payment": {
      "title": "Payment settings",
      "desc": "Manage your payment method."
    },
    "release": {
      "message": {
        "errorLoading": "Error loading release notes!"
      }
    },
    "manual": {
      "sidebar": {
        "title": "Help",
        "types": {
          "tour": "Map Builder Tour",
          "manual": "User Manual"
        }
      },
      "content": {
        "title": "User Guides",
        "description": "Select one of the guides to learn more about the Map Builder",
        "list": {
          "basicTour": {
            "title": "Basic Map Builder tour",
            "description": "A quick and short guide through the most important features"
          },
          "basicStudentTour": {
            "title": "Quick tour through the functions:",
            "description": "A brief introduction to great knowledge maps"
          },
          "baseKnowledge": {
            "title": "Knowledge Base",
            "description": "A complete and comprehensive overview of all functions."
          }
        }
      }
    },
    "quizzes": {
      "title": "Quiz Tool",
      "description": "Create and manage this quiz",
      "createQuiz": "Create new quiz",
      "label": {
        "name": "Name of the quiz",
        "description": "Optional: Description",
        "picture": "Optional: Title picture above questions"
      },
      "placeholder": {
        "name": "Give the quiz a name",
        "description": "Optional: Short description of the quiz"
      },
      "checkbox": {
        "expandableList": "Questions are presented in an expandable list",
        "correctAnswer": "Answer",
        "multipleAnswers": "Multiple answers"
      },
      "button": {
        "upload": "Upload title picture",
        "back": "Back to overview",
        "add": "Add question",
        "save": "Save quiz",
        "addAnswer": "Add answer"
      },
      "section": {
        "questions": "Add questions and answers"
      }
    },
    "link": {
      "title": "Insert link",
      "edit": "Edit link",
      "url": "URL",
      "urlPlaceholder": "https://… or #p=12",
      "or": "or",
      "text": "Link text",
      "newWindow": "Open in a new window",
      "chooseOnMap": "Pick on the map",
      "apply": "Apply",
      "remove": "Remove link",
      "cancel": "Cancel",
      "pickerTitle": "Pick a target on the map",
      "pickerHint": "Move the map to choose an area, or open a node to link straight to it.",
      "pickerNodeHint": "Close the open node to link to an area instead.",
      "pickerNode": "Node {id}",
      "pickerArea": "Area on layer {layer}",
      "pickerEmpty": "Nothing picked yet",
      "pickerUse": "Use this link",
      "pickerBlocked": "The map cannot be shown here. Pick a node from the list instead.",
      "pickerNodeFallback": "Node"
    },
    "external": {
      "title": "Connect external content from",
      "connectTitle": "Connection to:",
      "tooltip": "External Content",
      "search": "Search",
      "searchPlaceholder": "Search this source …",
      "shown": "Showing {shown} of {total}",
      "noResults": "Nothing found.",
      "loadMore": "Show more",
      "shownUnknownTotal": "Showing {shown}",
      "retry": "Try again",
      "emptyIn": "0 items found in {source}.",
      "error": {
        "network": "Could not reach the server. Check your connection and try again.",
        "notFound": "{source} is not connected for this account.",
        "rateLimited": "{source} is rate limiting requests. Wait a moment and try again.",
        "generic": "{source} could not be loaded (HTTP {status}). {detail}",
        "session": "Your session has ended. Sign in again to continue.",
        "notEntitled": "{source} is not enabled for this account. It has to be switched on before its content can be used.",
        "forbidden": "You do not have access to the external sources of this account.",
        "configuration": "{source} is not configured yet. Add its credentials under Account settings, Manage API.",
        "configurationField": "{source} is not configured correctly: check “{field}” under Account settings, Manage API.",
        "connectionGone": "That connection to {source} no longer exists. Pick another one.",
        "upstream": "{source} failed or refused the stored credentials. Check the connection under Account settings, Manage API."
      },
      "signIn": "Sign in again",
      "connection": "Connection",
      "frameSource": "Source: {source}",
      "type": {
        "livedoc": "Live Doc"
      },
      "message": {
        "livedocBlocked": "A Confluence Live Doc cannot be embedded. Pick a classic page, or convert it in Confluence."
      },
      "view": {
        "tiles": "Tiles",
        "list": "List",
        "folders": "Folders"
      }
    }
  },
  "tour": {
    "steps": {
      "welcome": {
        "title": "Welcome to the Map Builder!",
        "description": "Please follow this tour to learn the basics of how to create wonderfully designed, compelling knowledge maps."
      },
      "newProject": {
        "title": "Start a new project",
        "description": "Start from scratch or use a map template"
      },
      "structure": {
        "title": "Build the structure",
        "description": "Add nodes and draw connections"
      },
      "design": {
        "title": "Apply your design",
        "description": "Use templates to design the elements or apply your individual design"
      },
      "content": {
        "title": "Add content",
        "description": "Texts, fotos, videos, graphics – provide in depth information to each aspect."
      },
      "layers": {
        "title": "Create a deep dive experience",
        "description": "Add layers and adjust the visibility of nodes on different layers"
      },
      "publish": {
        "title": "Publish and share your map project",
        "description": "Choose access restrictions and one of the many ways to share your map."
      }
    },
    "stepsStudent": {
      "welcome": {
        "title": "Welcome and it's great to have you here!",
        "description": "This tour shows you briefly and concisely how easy it is to create beautiful knowledge maps."
      },
      "newProject": {
        "title": "Start a new project",
        "description": "Start your own map project or use your teacher’s template."
      },
      "points": {
        "title": "Draw points",
        "description": "Create new points and give them a design."
      },
      "connections": {
        "title": "Show how everything is connected",
        "description": "Draw lines connecting the points."
      },
      "explanations": {
        "title": "Explain each point",
        "description": "Texts, photos, videos - add content that explains the point."
      },
      "map": {
        "title": "Create a map to dive into!",
        "description": "Add layers and adjust the visibility of the points."
      },
      "simultaneous": {
        "title": "Work together with your group",
        "description": "Work on your knowledge map together with your classmates."
      },
      "publish": {
        "title": "Publish your knowledge map",
        "description": "Set the map to be presented live."
      }
    },
    "control": {
      "skip": "Skip",
      "back": "Back",
      "next": "Next",
      "start": "Let’s start"
    }
  },
  "tinymce": {
    "expandableList": "Expandable list",
    "expandableTitle": "Expandable title",
    "expandableContent": "Expandable content"
  },
  "multiSelection": {
    "selected": "selected",
    "delete": "Delete",
    "deselect": "Deselect All"
  },
  "kaia": {
    "trigger": {
      "label": "Chat with KAIA",
      "blockedBy": "{name} is using KAIA right now",
      "blocked": "KAIA is currently in use by another editor"
    },
    "header": {
      "phaseLabel": "Phase {index}/{total} — {name}",
      "verified": "verified",
      "inProgress": "in progress",
      "close": "Close",
      "settings": "Map settings: turn KAIA on or off for this map"
    },
    "phases": {
      "onboarding": "Onboarding",
      "sensemaking": "Sensemaking",
      "categoryFormation": "Category Formation",
      "structureChoice": "Structure Choice",
      "relevanceConstruction": "Relevance Construction",
      "layering": "Layering",
      "designContent": "Design and Content",
      "wayfinding": "Wayfinding"
    },
    "overview": {
      "title": "KAIA – Kontext AI Assistant",
      "description": "KAIA guides you through our proven process in 7 phases to build a comprehensive and comprehensible KontextMap.",
      "verified": "Successfully completed and verified",
      "inProgress": "In progress",
      "pending": "Pending",
      "phaseName": "Phase {index} {name}",
      "jump": "Jump to this phase"
    },
    "validation": {
      "title": "VALIDATION OF PHASE {phase}",
      "confirm": "Confirm",
      "edit": "Edit"
    },
    "review": {
      "refine": "Improve my answers"
    },
    "input": {
      "answer": "Write your answer …",
      "question": "Write your question …",
      "uploadUrl": "Paste a link, or attach a file"
    },
    "mock": {
      "onboarding": {
        "greeting": "Hello! I'm KAIA, your AI assistant for your KontextMap. I'll guide you step by step through the process – we'll build your map right here in the Map Builder. Every decision becomes immediately visible on the canvas. Would you like my help, or would you prefer to start on your own?",
        "greetingQuestion": "Would you like my help, or would you prefer to start on your own?",
        "optHelp": "I'd like your help",
        "optOwn": "I'd like to work on my own",
        "standBack": "All right, I'll step back. You can bring me in any time."
      },
      "phase1": {
        "topic": "What topic should your KontextMap cover? Describe it in one to three sentences.",
        "topicQ": "What topic should your KontextMap cover?",
        "purpose": {
          "km": "Knowledge Management & Documentation",
          "science": "Science & Research",
          "comm": "Communication & Orientation",
          "strategy": "Strategy & Change",
          "education": "Education & Training",
          "other": "I have a different purpose"
        },
        "start": {
          "expertise": "We have the expertise in our team and want to structure it",
          "content": "We have existing content (study, report) to present visually",
          "regulation": "We need to explain a set of regulations to our audience",
          "research": "The topic needs to be researched first"
        },
        "uploadOffer": "Upload your document and I'll analyze it.",
        "analyzing": "I'm analyzing the file …",
        "analyzed": "Done.",
        "goal": "What should users of your map understand or be able to do after using it?",
        "goalQ": "What should users of your map understand or be able to do after using it?",
        "goalExamples": "e.g. 'Know all relevant aspects of 5G for political decisions', 'Navigate the new EU regulation', 'Make well-informed decisions'",
        "audience": "Who is the map intended for?",
        "audienceQ": "Who is the map intended for?"
      },
      "validation": {
        "topic": "Topic:",
        "topicVal": "Digitalization in the agricultural sector",
        "purpose": "Purpose:",
        "purposeVal": "Communication & Orientation",
        "start": "Starting situation:",
        "startVal": "Existing content to be presented visually",
        "goal": "Communication goal:",
        "goalVal": "An overview of all relevant aspects to make better decisions"
      },
      "phase2": {
        "cat": {
          "a": "Fundamentals",
          "b": "Application",
          "c": "Framework"
        },
        "intro": "Next up are the main areas. How would you like to define the main areas?",
        "introQ": "How would you like to define the main areas?",
        "method": {
          "self": "I'll name the areas myself",
          "suggest": "Give me suggestions I can adjust",
          "fromDoc": "Create the areas from my document"
        },
        "outro": "Great – the main areas are now visible as points on the canvas. (Mock end of the demo flow.)"
      }
    },
    "steps": {
      "2_3": {
        "prompt": "Let me suggest some main areas based on your topic."
      },
      "2_3_confirm": {
        "prompt": "Keep, rename, or remove any area — then continue."
      },
      "2_1_manual": {
        "prompt": "Name your main areas yourself — type one name and send it. Tap “I'm done” when you're finished."
      },
      "2_1_material": {
        "prompt": "Share a document or a link and I’ll suggest the main areas from it. Attach what you have, then tap “Continue”."
      },
      "2_5": {
        "prompt": "Here are your main areas. Does this look right?",
        "value": "Defined on the canvas"
      },
      "3_1": {
        "prompt": "Which structure type fits your topic?"
      },
      "3_1_order": {
        "prompt": "Your areas will line up in a sequence as we add them."
      },
      "3_1_help": {
        "prompt": "Mindmap branches from the center; Process is a sequence; Context map shows cross-links; Islands are independent blocks. Which fits best?"
      },
      "3_2": {
        "prompt": "We'll build your map with this structure. Ready to add your main areas?"
      },
      "4_0": {
        "prompt": "Which area would you like to develop first?",
        "promptNext": "Which area next? Pick one, or finish with “I'm done”."
      },
      "4_1": {
        "prompt": "How would you like to develop the subpoints for {category}?"
      },
      "4_1_manual": {
        "prompt": "Name the subpoints for {category} yourself — type one name and send it. Tap “I'm done” when you're finished."
      },
      "4_1_material": {
        "prompt": "Share a document or a link and I’ll suggest subpoints from it. Attach what you have, then tap “Continue”."
      },
      "4_2b": {
        "prompt": "Let me suggest some subpoints for {category}."
      },
      "4_2b_confirm": {
        "prompt": "Keep, rename, or remove subpoints — then continue."
      },
      "4_8": {
        "prompt": "Here's your full structure on the canvas. Does it work?",
        "value": "Built on the canvas"
      },
      "5_1": {
        "prompt": "How many layers should your map have?"
      },
      "5_1_accept": {
        "prompt": "I'll set up a sensible number of layers for your structure."
      },
      "5_1_override": {
        "prompt": "How many layers would you like? Enter a number."
      },
      "5_3": {
        "prompt": "Assigning your points to the layers …"
      },
      "5_4": {
        "prompt": "Your layer structure is set. Does this look right?",
        "value": "Set on the canvas"
      },
      "1_0": {
        "prompt": "Your map already has content. Shall I take a look and suggest the foundation, or would you rather answer the questions yourself?"
      },
      "1_1": {
        "prompt": "Let's start with the heart of your map.",
        "emphasis": "What topic should your KontextMap cover?"
      },
      "1_2": {
        "prompt": "In which area will your map be used?"
      },
      "1_2_other": {
        "prompt": "What purpose do you have?"
      },
      "1_2_detail": {
        "prompt": "You chose “{purpose}”. Can you describe a bit more precisely what you want to achieve with it?"
      },
      "1_3": {
        "prompt": "What is your starting situation?"
      },
      "1_3_other": {
        "prompt": "Briefly describe your starting situation."
      },
      "1_4": {
        "prompt": "What should users understand or be able to do after using your map?",
        "examples": "e.g. 'Know all relevant aspects of 5G for political decisions', 'Navigate the new EU regulation', 'Make well-informed decisions'"
      },
      "1_5": {
        "prompt": "Who is the map intended for?"
      },
      "1_6": {
        "prompt": "Let me quickly check the scope of your topic …"
      },
      "1_7": {
        "prompt": "Here's a summary of your foundation. Does this look right?"
      },
      "2_1": {
        "prompt": "Now let's define your main areas. How would you like to do it?"
      },
      "6_0": {
        "prompt": "Next up are design and content. Which would you like to start with?"
      },
      "6_0_help": {
        "prompt": "I recommend design first, then content — you'll see the look while writing. We do navigation at the very end."
      },
      "6A": {
        "prompt": "Design support is coming soon — I'll mark the design step as ready for now."
      },
      "6B": {
        "prompt": "Now connect your own AI in the Map Builder to write each point's content — I provide the full context (topic, audience, goal, structure, map memory). I'll mark content as ready."
      },
      "6C": {
        "prompt": "Design and content are in place. Ready to finalize navigation?",
        "value": "Marked ready"
      },
      "7_1": {
        "prompt": "Let's set up navigation. How should the entry points be structured?"
      },
      "7_1_stub": {
        "prompt": "Automatic navigation points are coming soon — for now you can add them yourself in the Map Builder."
      },
      "7_5": {
        "prompt": "Your navigation is set. Does this look right?",
        "value": "Set on Layer 1"
      },
      "4_4_offer": {
        "prompt": "Want a few more ideas for {category}?"
      },
      "4_4": {
        "prompt": "A few more subpoints you could add to {category}:"
      },
      "4_4_confirm": {
        "prompt": "Keep what fits — then continue."
      },
      "4_5": {
        "prompt": "Which of these points in {category} should stay as their own node on the map?"
      },
      "4_5_confirm": {
        "prompt": "Done reviewing — continue."
      },
      "4_5_done": {
        "prompt": "“{category}” is done."
      },
      "resume": {
        "prompt": "Want to continue where you left off, or jump to a specific phase?"
      },
      "resume_jump": {
        "prompt": "Which phase would you like to jump to?"
      },
      "4_3": {
        "prompt": "Some of these points could have further aspects. Deepen now, or move on?"
      },
      "4_3_pick": {
        "prompt": "Which point in {category} would you like to add sub-aspects to?"
      },
      "4_3_suggest": {
        "prompt": "Here are some sub-aspects for {point}."
      },
      "4_3_confirm": {
        "prompt": "Keep what fits — then continue."
      },
      "4_7": {
        "prompt": "Let me suggest cross-connections between related points that aren't linked yet."
      },
      "4_7_confirm": {
        "prompt": "Keep the connections that fit — then continue."
      },
      "refine_offer": {
        "prompt": "Would you like to sharpen any of your earlier answers first? That helps me give better feedback and suggestions."
      },
      "refine_form": {
        "prompt": "Here are your answers — edit any of them, then Re-check or continue."
      },
      "completed": {
        "prompt": "Your map is complete. Would you like to revisit a phase, change the structure, or close?"
      },
      "completed_jump": {
        "prompt": "Which phase would you like to revisit?"
      },
      "completed_change_structure": {
        "prompt": "Which structure should I switch to? Your areas and points stay — only their arrangement changes."
      },
      "7_1_nav": {
        "prompt": "I'll add a navigation point for each area so your readers can zoom straight to it."
      },
      "sensemaking_review": {
        "analyzing": "Let me take a look at your map and pull the basics together …"
      }
    },
    "fields": {
      "categories": "Main areas",
      "structure_type": "Structure type",
      "structure": "Structure",
      "layers": "Layers",
      "topic": "Topic",
      "purpose": "Purpose",
      "purpose_detail": "Purpose details",
      "starting_situation": "Starting situation",
      "communication_goal": "Communication goal",
      "audience": "Target audience",
      "prior_knowledge": "Prior knowledge",
      "design_content": "Design & content",
      "navigation": "Navigation",
      "anchor": "Anchor point"
    },
    "options": {
      "flow": {
        "continue": "Continue",
        "done": "I'm done",
        "add_own": "I'll add my own"
      },
      "supplements": {
        "more": "Yes, a few more ideas",
        "skip": "No, move on"
      },
      "onboarding": {
        "help": "I'd like your help",
        "own": "I'd like to work on my own"
      },
      "sensemaking": {
        "purpose": {
          "knowledge_management": "Knowledge Management & Documentation",
          "science_research": "Science & Research",
          "communication_orientation": "Communication & Orientation",
          "strategy_change": "Strategy & Change",
          "education_training": "Education & Training",
          "public_sector": "Public Sector & Smart Governance",
          "compliance_law": "Compliance & Law",
          "other": "I have a different purpose"
        },
        "starting_situation": {
          "have_expertise": "We have the expertise and want to structure it",
          "have_content": "We have existing content to present visually",
          "explain_regulations": "We need to explain regulations to our audience",
          "needs_research": "The topic needs to be researched first",
          "other": "I have a different starting situation"
        }
      },
      "category_formation": {
        "manual": "I'll name them myself",
        "suggestions": "Give me suggestions",
        "material": "Use my document"
      },
      "structure_choice": {
        "mindmap": "Mindmap",
        "process": "Process",
        "network": "Context map",
        "islands": "Islands",
        "help": "Help me decide"
      },
      "relevance_construction": {
        "choose_category": "Choose a category"
      },
      "layering": {
        "accept_recommendation": "Use the recommendation",
        "override": "Set it myself"
      },
      "design_and_content": {
        "design_first": "Design first",
        "content_first": "Content first",
        "help": "Help me decide"
      },
      "wayfinding": {
        "category_links": "Links to categories",
        "guiding_question_links": "Guiding questions",
        "user_defined_links": "I'll define them"
      },
      "resume": {
        "continue": "Continue where I left off",
        "jump": "Jump to a phase"
      },
      "deepen": {
        "deepen": "Deepen now",
        "skip": "Move on"
      },
      "refine": {
        "adjust": "Improve my answers",
        "continue": "Continue",
        "recheck": "Check again",
        "done": "Done — continue",
        "topic": "Topic",
        "purpose": "Purpose",
        "starting_situation": "Starting situation",
        "communication_goal": "Communication goal",
        "audience": "Target audience"
      },
      "completed": {
        "revisit": "Revisit a phase",
        "change_structure": "Change the structure",
        "close": "Close KAIA"
      },
      "removeCategory": "Remove this category and everything under it",
      "removeCategoryConfirm": "Remove “{name}” and all of its sub-categories and points? This cannot be undone.",
      "recalcLayout": "Recalculate layout",
      "recalcLayoutTitle": "Re-apply this layout — re-arranges the points without changing anything else",
      "anchor": {
        "use_selected": "Use selected point",
        "cancel": "Cancel"
      },
      "sensemaking_entry": {
        "answer": "I'll answer the questions",
        "analyse": "Analyse my map"
      }
    },
    "prose": {
      "suggestionsUnavailable": "I couldn't get suggestions this time.",
      "suggestionsKeepFailing": "Suggestions keep failing right now — let's move on and try a different way.",
      "aiTimeout": "The AI service took too long to respond — you can try again in a moment.",
      "reviewUnavailable": "I couldn't review that just now — let's keep going.",
      "fallbackArea": "this area",
      "fallbackPoint": "that point",
      "fallbackPurpose": "your purpose",
      "affectedPhases": "Heads up — editing this may affect: {phases}. Nothing is reset; you can revise it here.",
      "manualAdded": "Added “{name}”. Add another, or tap “I'm done”.",
      "manualAddFailed": "I couldn't create that point. Try again, or tap “I'm done”.",
      "greeting": {
        "blank": "Hi! I'm KAIA, your AI assistant for your KontextMap. I'll guide you step by step — we build it right here in the Map Builder. Would you like my help, or work on your own?",
        "template": "Hi! I'm KAIA. I see you're starting from a template — I can help you tailor it. Would you like my help, or work on your own?",
        "welcomeBack": "Welcome back! Your map is already in progress."
      },
      "cannotAnswerYet": "I can't answer free questions yet — please use the options above, or keep going on your own.",
      "steppedBack": "All right, I'll step back. You can bring me in any time.",
      "intro": "Hi! I'm KAIA, your assistant for building this KontextMap. We'll work through it step by step, right here in the Map Builder.",
      "completed": "Your KontextMap is complete – every phase is done. You can publish it now.",
      "materialAdded": "Added “{name}”. I’m reading it now and will build on it as soon as I’m done.",
      "materialAddFailed": "I couldn’t attach that. Try a PDF, Word, PowerPoint or image — or a link.",
      "sensemakingUnavailable": "I couldn't analyze your map automatically — let's put the basics together instead.",
      "pickAnchor": "Select a point on the map, then choose “Use selected point”.",
      "anchorSet": "Anchor point set to “{name}”.",
      "noNodeSelected": "No point selected yet — click one on the map first."
    },
    "canvas": {
      "updated": "The canvas was updated."
    },
    "thinking": {
      "default": "Let me think …",
      "categories": "Coming up with categories …",
      "subpoints": "Coming up with subpoints …",
      "structure": "Thinking about the structure …",
      "connections": "Looking for connections …",
      "layer_count": "Working out the layers …",
      "topic_scope": "Checking the topic scope …",
      "category_quality": "Reviewing the categories …",
      "balance": "Checking the balance …",
      "reachability": "Checking navigation …",
      "sensemaking": "Analyzing your map …"
    },
    "openQuestion": {
      "submit": "Send"
    },
    "suggestion": {
      "keep": "Keep",
      "remove": "Remove",
      "rename": "Rename",
      "keepAll": "Keep all",
      "removeAll": "Remove all"
    },
    "relevance": {
      "keep": "Keep",
      "memory": "Move to map memory",
      "unsure": "Unsure",
      "remove": "Remove",
      "keepAll": "Keep all",
      "memoryAll": "Move all to map memory",
      "unsureAll": "Unsure about all"
    },
    "materials": {
      "title": "Documents for this map",
      "hint": "My suggestions and the text generated for any point build on these documents. Readers never see them, and they are never cited.",
      "none": "No document is attached to this map yet.",
      "untitled": "Attached document",
      "reading": "Reading the document…",
      "failed": "This document could not be read.",
      "fromDeletedPoint": "From a deleted point"
    }
  },
  "features": {
    "headline": {
      "client": "Client {name}",
      "package": "Package {name}"
    },
    "section": {
      "quotas": "Quotas",
      "roleQuotas": "User quotas per role",
      "permissions": "Permissions",
      "features": "Features",
      "externalContent": "External content providers",
      "payment": "Payment settings",
      "validity": "Validity",
      "content": "Content"
    },
    "quota": {
      "layer": "Layer quota",
      "map": "Map quota",
      "storage": "Storage quota",
      "liveMap": "Live maps quota",
      "template": "Template quota",
      "traffic": "Traffic quota",
      "user": "User quota",
      "admin": "Admin user quota",
      "editor": "Editor user quota",
      "guest": "Guest user quota",
      "student": "Student user quota",
      "activeReaders": "Active readers quota",
      "editingUser": "Editing users quota"
    },
    "quotaHint": {
      "layer": "Maximum number of layers per map",
      "map": "Maximum number of maps",
      "storage": "Limit of stored media assets in MiB",
      "liveMap": "Maximum number of maps that may be published",
      "template": "Maximum number of custom object templates",
      "traffic": "Monthly limit of transferred data in MiB",
      "user": "Maximum number of users",
      "admin": "Maximum number of users with the admin role",
      "editor": "Maximum number of users with the editor role",
      "guest": "Maximum number of users with the guest role",
      "student": "Maximum number of users with the student role",
      "activeReaders": "Monthly limit of visitors",
      "editingUser": "Maximum number of users that may edit maps"
    },
    "can": {
      "editMap": "Edit maps",
      "editPopups": "Edit popup contents",
      "embedMap": "Embed maps on other sites",
      "publicMaps": "Publish maps",
      "privateMaps": "Keep draft maps",
      "selectDesignTemplates": "Use object templates",
      "saveMapState": "Save the reader’s map state"
    },
    "has": {
      "analytics": "Analytics in maps",
      "articles": "Long-read articles",
      "assistant": "KAIA map-building assistant",
      "contentLlm": "AI content generation",
      "assetManagement": "Media asset management",
      "cname": "Custom domain (CNAME)",
      "cookieConsent": "Cookie consent dialog",
      "customDesign": "Design settings on points and connections",
      "customLoginPage": "Custom login page",
      "designTemplates": "Create object templates",
      "editorial": "Editor’s Note",
      "globalDesign": "Global design rules",
      "glossary": "Glossary",
      "i18n": "Multiple languages",
      "mapHeader": "Map header",
      "mcpServer": "MCP server",
      "mediaTemplates": "Media templates",
      "meteredMaps": "Metered maps",
      "mfa": "Two-factor authentication",
      "premiumTemplates": "Premium templates",
      "quizzes": "Quizzes",
      "references": "References and bibliography",
      "search": "Full-text search",
      "seo": "Additional SEO options",
      "socialNetworkSharing": "Social sharing buttons in popups",
      "studentRole": "Student role",
      "subdomain": "Subdomain",
      "templates": "Map templates",
      "toc": "Table of contents",
      "translationService": "Translation service",
      "userAccessControl": "Map-specific access control"
    },
    "field": {
      "clientName": "Client’s name",
      "packageName": "Package name",
      "paymentProvider": "Payment provider",
      "customerId": "Customer ID",
      "activeSince": "Active since",
      "activeUntil": "Active until",
      "testingPeriodUntil": "Testing period until",
      "testingPeriodDays": "Testing period in days",
      "dateHint": "YYYY-MM-DD hh:mm:ss",
      "fonts": "Fonts",
      "mediaCategories": "Media categories",
      "templateThemes": "Template themes",
      "traffic": "Included traffic in MiB",
      "slug": "Slug",
      "slugHint": "Identifier derived from the name. The payment provider matches its products against it."
    },
    "save": "Save",
    "savedMessage": "Settings successfully changed!",
    "loadError": "Error occurred while loading the settings!",
    "saveError": "Error occurred while saving the settings!",
    "categoriesError": "Error occurred while loading media categories",
    "payment": {
      "noProvider": "None",
      "notLinked": "This package is not connected to a product yet, so its checkout links do not work.",
      "chooseProduct": "Existing product",
      "chooseOtherProduct": "Move to another product",
      "newProduct": "Or create a new product",
      "link": "Connect",
      "move": "Move",
      "create": "Create and connect",
      "unlink": "Disconnect",
      "working": "Talking to the payment provider…",
      "openAtProvider": "Edit at {provider}",
      "productTaken": "{name} (belongs to {slug})",
      "extensions": "Add-ons sold with this package. Maintained at the payment provider.",
      "missingPrices": "No price yet for: {intervals}. Customers cannot buy that billing period until you add one at the payment provider.",
      "stateMissing": "The connected product no longer exists at the payment provider. Connect another one.",
      "stateMismatched": "This product belongs to a different package, or was connected by hand at the payment provider. Connect it here to take it over.",
      "loadError": "The payment provider could not be reached.",
      "linkError": "The product could not be connected.",
      "createError": "The product could not be created.",
      "unlinkError": "The product could not be disconnected.",
      "detected": "{provider} already sells this package as “{name}”. Record that here so this package can be renamed, moved to another product or disconnected from the dashboard.",
      "adopt": "Use this product",
      "adoptHint": "Nothing changes at the payment provider and checkout keeps working exactly as it does now."
    }
  },
  "packages": {
    "headerTitle": "Packages",
    "addPackage": "Add new package",
    "createPackage": "Create package",
    "cancel": "Cancel",
    "packageName": "What is the package called?",
    "cloneName": "Name of the copy",
    "inactive": "Inactive",
    "edit": "Edit package",
    "clone": "Duplicate package",
    "deletePackage": "Delete finally",
    "copyLinkYear": "Copy yearly purchase link",
    "copyLinkMonth": "Copy monthly purchase link",
    "linkCopied": "Purchase link copied to the clipboard",
    "linkCopyFailed": "The purchase link could not be copied",
    "maps": "Number of maps:",
    "users": "Number of users:",
    "trial": "Trial period:",
    "trialDays": "{count} days",
    "noTrial": "None",
    "unlimited": "Unlimited",
    "createError": "The package could not be created",
    "cloneError": "The package could not be duplicated",
    "deleteError": "The package could not be deleted",
    "searchPlaceholder": "Search packages...",
    "copySuffix": "{name} (copy)",
    "cloneTitle": "Duplicate package",
    "cloneConfirm": "Duplicate",
    "payment": {
      "linked": "Sold as a product",
      "linkedHint": "This package is connected to a product at its payment provider and can be bought.",
      "missingPrices": "Price missing",
      "detected": "Connection not recorded",
      "detectedHint": "The payment provider already sells this package, but the connection is not recorded here yet. Open the package to record it.",
      "missing": "Product gone",
      "mismatched": "Wrong product",
      "unlinked": "Not connected"
    }
  },
  "fonts": {
    "headerTitle": "Fonts",
    "searchPlaceholder": "Search fonts...",
    "loadError": "The fonts could not be loaded",
    "empty": "No fonts yet",
    "emptySearch": "No font matches this search",
    "table": {
      "id": "ID",
      "family": "Family",
      "from": "Source",
      "created": "Added",
      "actions": "Actions",
      "updated": "Changed"
    },
    "from": {
      "google": "Google Fonts",
      "library": "Font library",
      "external": "External",
      "unknown": "Unknown"
    },
    "fromDerived": "Not recorded; read from the stylesheet URL",
    "servedFrom": "Served from {host}",
    "editFont": "Edit font",
    "removeFont": "Delete font",
    "import": {
      "open": "Import font",
      "title": "Import a font",
      "description": "Pick where the font comes from. The options do this:",
      "sourceLabel": "Import from",
      "sourceHints": {
        "google": "Downloads the family from Google Fonts and stores it here. Maps then serve the font themselves, so no visitor's browser asks Google for it.",
        "library": "Registers a family that is already stored here. Nothing is downloaded; the font only becomes selectable in the Map Builder.",
        "external": "Links a stylesheet at an address you enter. The font files stay on that host and are loaded from there."
      },
      "external": "External stylesheet",
      "externalDescription": "Use this only for a host of your own: visitors load the font from it directly.",
      "url": "URL of the stylesheet",
      "searchPlaceholder": "Find a family...",
      "variants": "{count} variants",
      "noVariants": "No variants",
      "alreadyImported": "Already imported",
      "empty": "No families found",
      "familiesError": "The families could not be loaded",
      "chosenFamily": "Family",
      "displayName": "Display name",
      "displayNameHint": "Defaults to the family name",
      "fallback": "Fallback",
      "fallbackHint": "What a browser shows while the font loads",
      "submit": "Import",
      "cancel": "Cancel",
      "error": "The font could not be imported",
      "conflict": "A font for this family already exists",
      "success": "{name} has been imported"
    },
    "edit": {
      "title": "Edit font",
      "name": "Display name",
      "family": "Font stack",
      "familyHint": "As used in CSS, ending in a generic family",
      "source": "Stylesheet",
      "refresh": "Update from source",
      "refreshHint": "Reads the stylesheet again and replaces the faces of the font",
      "refreshUnavailable": "Where this font came from was never recorded, so it cannot be re-read automatically",
      "save": "Save",
      "cancel": "Cancel",
      "error": "The font could not be saved",
      "refreshError": "The font could not be updated from its source",
      "refreshed": "{name} has been updated from its source"
    },
    "remove": {
      "title": "Delete font",
      "question": "Do you really want to delete the font “{name}”?",
      "clients": "It is available to {count} client(s): {clients}",
      "noClients": "No client uses this font.",
      "warning": "It will be withdrawn from those clients, and every map component using it falls back to the design default.",
      "confirm": "Delete finally",
      "cancel": "Cancel",
      "error": "The font could not be deleted",
      "success": "{name} has been deleted"
    }
  }
}
